module.exports = __webpack_public_path__ + "static/images/smoothness/ui-bg_highlight-soft_75_cccccc_1x100.png";